import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Container, CardGroup, Card, Grid, GridColumn, Input, Loader } from 'semantic-ui-react'

const MGGames = ({ gameClicked }) => {
    const [isLoading, setIsLoading] = useState(true)
    const [isSearching, setIsSearching] = useState(false)
    const [searchString, setSearchString] = useState('')
    const [games, setGames] = useState([])
    
    useEffect(() => {
        axios.get('/api/available_games/mg').then(res => { 
            const sortedGames = [...res.data].sort((a, b) =>
                a.post_title.localeCompare(b.post_title)
            )
            setGames(sortedGames)
            setIsLoading(false)
        }).catch(err => {
            setIsLoading(false)
            alert('Fail to get MG games, please try again. Error: ' + err)
        })
    }, [])

    const handleChangeSearchField = e => {
        const { value } = e.target
        if (value === '') {
            setIsSearching(false)
        } else {
            setIsSearching(true)
            setSearchString(value)
        }
    }
    const handleGameClicked = game => {
        gameClicked(game.ID, game.post_title)
    }

    const renderCards = () => {
        if (!games) return 
        if (!Array.isArray(games)) return
        const data = isSearching ? games.filter(games => games.post_title.toLowerCase()?.includes(searchString.toLowerCase())) : games
        const cards = []
        for (const [i, game] of data.entries()) {
            cards.push(<Card key={i} link style={{ backgroundColor: '#1b1c1d' }} header={<span style={{ color: '#E6E6E6', whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-word' }}>{game.post_title}</span>} onClick={() => handleGameClicked(game)}/>)
        }
        return <CardGroup doubling itemsPerRow={6}>{cards}</CardGroup>
    }

    if (isLoading) return(<Loader inverted active/>)

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Grid style={{ marginTop: 10, marginBottom: 15 }}>
                <GridColumn floated="left" width={5}>
                    <h1 style={{ color: 'white' }}>MooGold</h1>
                </GridColumn>
                <GridColumn width={6}>
                    <Input inverted fluid action={{ icon: 'search', color: 'teal', inverted: true }} placeholder="Search game..." onChange={handleChangeSearchField} style={{ border: '1px #333 solid' }} input={<input style={{ backgroundColor: '#1b1c1d', color: 'white' }} />}/>
                </GridColumn>
                <GridColumn floated="right" width={5}>
                </GridColumn>
            </Grid>
            {renderCards()}
        </Container>
    )
}

export default MGGames